import ViewWrapper from 'components/view-wrapper/view-wrapper.vue';
import InnerFrame from 'components/inner-frame/inner-frame';
const bizLine = 'wenchuang';
import RouteBuilder from './routeBuilder';
let wcBuilder = new RouteBuilder(bizLine, ViewWrapper, InnerFrame);
import AcademyHome from 'views/academy/HomePage.vue';
let xgxy = RouteBuilder.buildXAXY(wcBuilder, AcademyHome);

function getBizLineRouteName(name) {
    return bizLine + name;
}
export default [{
    name: getBizLineRouteName('home'),
    path: '',
    component: require('components/nhomepage/nhomepage.vue'),
    meta: {
        title: '首页',
        icon: 'turbo-ui-home',
        bizLineId: 1
    }
}, {
    name: getBizLineRouteName('order'),
    path: 'order',
    component: ViewWrapper,
    meta: {
        title: '订单管理',
        icon: 'assignment'
    },
    children: [{
        name: getBizLineRouteName('orderList'),
        path: 'orderList',
        component: require('views/wenchuang/orderList/Main.vue'),
        meta: {
            title: '订单列表'
        }
    }, {
        name: getBizLineRouteName('shippingOrderList'),
        path: 'shippingOrderList',
        component: require('views/wenchuang/shippingOrder/Main.vue'),
        meta: {
            title: '待出货订单'
        }
    }, {
        name: getBizLineRouteName('refundOrderList'),
        path: 'refundOrderList',
        component: require('views/wenchuang/refundOrder/Main.vue'),
        meta: {
            title: '待退款订单'
        }
    }, {
        name: getBizLineRouteName('OrderDetails'),
        path: 'refundOrderList',
        component: require('views/wenchuang/orderDetails/Main.vue'),
        meta: {
            title: '订单详情',
            notMenu: true
        }
    }]
}, xgxy];


// WEBPACK FOOTER //
// ./src/router/router.wenchuang.js